import React, { PureComponent, Fragment } from "react";
import * as RBT from "react-bootstrap";
import * as faIcon from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Scrollbars } from "react-custom-scrollbars";
import Tooltip from "react-bootstrap/Tooltip";
import Timer from "react-compound-timer";
import Parser from "html-react-parser";
import ReactPlayer from "react-player/lazy";
import Datetime from "react-datetime";
import Hotkeys from "react-hot-keys";
import Flatpickr from "react-flatpickr";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import $ from "jquery";
import { Lightbox } from "react-modal-image";
import AmrPlay from "./AmrPlay";
import ScheduleMessageArea from "./ScheduleMessageArea";
import ShortcodeArea from "./ShortcodeArea";
import ReactImageFallback from "react-image-fallback";
import { autoassign, setfullstory, setLeadProcessStatus, setReloadReply } from "../../Store/actions/loginActions";
import { AJAX_REQUEST, GET_STORAGE, iniScheduleDateTime, IDLE_SESSION_TIMEOUT, sentryErrorLog } from "../../Constants/AppConstants";

let activityInterval = '';
let idleInterval = '';

class Conversations extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      rightContainerType: "autoAssign", // autoAssign, autoAssignUnavailable
      leadProcessStatus: "processing", //done, pending

      //added by farhad
      currentContactID: this.props.currentContactID,
      currentGymOwnerID: this.props.currentGymOwnerID,
      assignedContactID: this.props.assignedContactID,
      assignedGymOwnerID: this.props.assignedGymOwnerID,

      Socket: this.props.Socket,
      isAutoAssigned: this.props.isAutoAssigned,
      autoAssignStartTime: Date.now(),
      isAutoAssignable: this.props.isAutoAssignable,
      callAutoAssign: true,

      // for auto asing area state
      contact_name: "",
      owner_name: "",
      promo_name: "",
      cat_campaign_title: "",
      sub_cat_campaign_title: "",
      owner_time: moment(),
      owner_timezone_array: {
        date: moment(),
        timezone_type: 3,
        timezone: "America/Chicago",
      },
      opt_out: "no",
      blacklist: "no",
      is_archived: "no",
      can_escalate: "no",
      is_assigned_to_gymowner: "no",
      is_assigned_to_admin: "no",
      follow_up: false,
      is_scheduled: "no",
      is_handled: "no",
      is_handled_by: "",
      schedule_date_time: iniScheduleDateTime(),
      schedule_date_time_formatted: "",
      schedule_id: '',
      messages: [],
      scheduleDateRange: '',
      scheduleTimeRange: '',
      suggestedTimes: [],
      suggestedDatepickerOpen: false,
      suggestedTimesLoading: true,
      lastMessageId: '',
      usesNewCalendar: "no",

      errorMsg: "",
      offset: 0,
      hasmore: true,
      activityLoading: true,
      message_loading: true,
      hide_message_area: false,
      message_sending_loading: false,

      // Modal
      addScheduleModalShow: false,
      reScheduleModalShow: false,
      cancelScheduleModalShow: false,
      leadActionModalDisplay: false,
      releaseConversationShow: false,
      conversationReleaseModalShow: false,
      contactIsLiveModal: false,
      chooseHour: false,
      chooseMinute: false,
      notAssignedtoYou: false,
      ishandledModal: false,
      ismanualHandledModal: false,

      // Acuity Calendar
      acuityurl: '',
      showIframe: false,
      acuityCalendarLoading: true,

      // Short Codes
      shortCodeLoading: true,
      shortCodeList: [],
      errorShortCodeMessage: '',
      mostUsedShortcodeLoading: true,
      mostUsedShortCodeList: [],
      errorMostUsedShortCodeMessage: "",

      activityMaxTime: IDLE_SESSION_TIMEOUT,
      activityTimeLeft: localStorage.getItem("activityTimeLeft") ? localStorage.getItem("activityTimeLeft") : IDLE_SESSION_TIMEOUT,
      idleMaxTime: IDLE_SESSION_TIMEOUT,
      idleTimeLeft: localStorage.getItem("idleTimeLeft") ? localStorage.getItem("idleTimeLeft") : IDLE_SESSION_TIMEOUT,
      logoutUser: 1,

      // Settings
      pauseScheduleMessage: this.props.pauseScheduleMessage,

      reconnectionErr: 1,
      leadCountSource: 'socket',

      //image lightbox
      openLightbox: false,
      urlToLargeImageFile: '',
      urlToHugeImageFile: '',
      alt: '',

      // full story
      lastFullStoryTime: '',

      scrollbarMaxHeight: '100%',
      leadNewMessageFound: false,
      closedContactIdConversation: 0
    }

    this.messageScrollbars = React.createRef();
  }

  componentDidMount() {
    //close conversation from iframe
    window.addEventListener('message', event => {
      // IMPORTANT: check the origin of the data!
      if (event.origin !== "https://calendar-dev.usealan.com" && event.origin !== "https://calendar.usealan.com")
        return;
      if(this.state.currentContactID !== this.state.closedContactIdConversation){
        this.leadProcessDone();
        this.setState({
          closedContactIdConversation: this.state.currentContactID
        }, () => { });
      }
  });

    //get lead information
    let assign_type = this.state.isAutoAssigned ? 'auto' : 'manual';
    this.setCurrentContact(this.state.currentContactID, this.state.currentGymOwnerID, assign_type);
    //console.log('current contact id: ', this.state.currentContactID);
    // console.log('current user id: ', this.state.currentGymOwnerID);

    this.props.setLeadProcessStatus("processing");

    this.newMessageFound();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      if (this.props.isFullStory !== prevProps.isFullStory && (prevProps.isFullStory === 'yes' || prevProps.isFullStory === 'no') && prevState.currentContactID === this.state.currentContactID) {
        if (this.props.auth.isFullStory === "yes" || this.props.auth.isFullStory === "no") {
          this.setState({
            messages: [],
            offset: 0,
            hasmore: true,
            lastFullStoryTime: '',
            leadNewMessageFound: false,
          }, () => {
            this.getMessages(this.state.offset, 'scrolltobottom', this.state.currentContactID, this.state.currentGymOwnerID, this.props.auth.isFullStory);
          })
        }
      }
    }

    if (this.state.leadNewMessageFound !== prevState.leadNewMessageFound) {
      //check lead new message
      if (this.state.leadNewMessageFound === true) {
        // console.log('checkNewMessage leadNewMessageFound props: ', this.state.leadNewMessageFound);
        this.getMessages(0, 'scrolltobottom', this.state.currentContactID, this.state.currentGymOwnerID);
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    this.props.setfullstory('hide');
  }

  setCurrentContact = (currentContactID, currentGymOwnerID, assignType = 'manual', loadingState = true) => {
    //console.log('setCurrentContact called');
    let iframe_exists = document.querySelectorAll(".shedule-messages-container>iframe");
    if (iframe_exists) {
      iframe_exists.src = '';
    }
    this.setState({
      currentContactID,
      currentGymOwnerID,
      messages: loadingState ? [] : [],
      offset: 0,
      hasmore: true,
      activityLoading: loadingState ? loadingState : false,
      acuityCalendarLoading: loadingState ? loadingState : false,
      acuityurl: '',
      showIframe: false,
      shortCodeLoading: loadingState ? loadingState : false,
      shortCodeList: [],
      errorShortCodeMessage: '',
      mostUsedShortcodeLoading: loadingState ? loadingState : false,
      mostUsedShortCodeList: [],
      errorMostUsedShortCodeMessage: "",
      suggestedTimes: [],
      suggestedDatepickerOpen: false,
      suggestedTimesLoading: loadingState ? loadingState : false,
      isAutoAssigned: (assignType === 'auto') ? true : false,
      chooseHour: false,
      chooseMinute: false,
      is_handled_by: "",
      lastFullStoryTime: '',
      callAutoAssign: false,
    }, () => { });
    let userdata = JSON.parse(GET_STORAGE("plu"));

    if ((currentContactID !== '') && (currentGymOwnerID !== '') && userdata) {
      clearInterval(idleInterval);
      this.loadActivityInfo(currentContactID, currentGymOwnerID, 0, assignType);
    }

    if (assignType === 'auto') {
      $('#fullLatestList_scrollbar').find('div.list-group').find('div.list-group-item').removeClass('active');
    }
  };

  // for auto assign area //comments goes
  loadActivityInfo = (currentContactID, currentGymOwnerID, offsetdata, assignType = 'manual') => {
    const postData = {
      user_id: currentGymOwnerID,
      contact_id: currentContactID,
      assign_type: assignType,
    };
    //console.log('getLeadDetails api call: ', postData);
    let userdata = JSON.parse(GET_STORAGE("plu"));
    if (userdata) {
      AJAX_REQUEST("POST", "v2/operator/getLeadDetails", postData).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          const leadDetails = results.response.data;

          this.props.setfullstory('no');

          this.setState({
            hide_message_area: false,
            activityLoading: false,
            message_loading: false,
            contact_name: leadDetails.contact_name,
            owner_name: leadDetails.owner_name,
            promo_name: leadDetails.promo_name,
            cat_campaign_title: leadDetails.cat_campaign_title,
            sub_cat_campaign_title: leadDetails.sub_cat_campaign_title,
            opt_out: leadDetails.opt_out,
            blacklist: leadDetails.blacklist,
            is_archived: leadDetails.is_archived,
            can_escalate: leadDetails.can_escalate,
            is_assigned_to_gymowner: leadDetails.is_assigned_to_gymowner,
            is_assigned_to_admin: leadDetails.is_assigned_to_admin,
            is_scheduled: (leadDetails.is_scheduled === "yes" && leadDetails.is_past === "no") ? "yes" : "no",
            schedule_date_time_formatted: leadDetails.schedule_date_time_formatted,
            schedule_id: leadDetails.schedule_data ? leadDetails.schedule_data.id : '',
            scrollbarMaxHeight: (leadDetails.is_scheduled === 'no') ? '90%' : '100%',
            is_handled: leadDetails.is_handled,
            ishandledModal: (leadDetails.is_handled === "yes" && assignType !== "auto" && this.state.assignedContactID && currentContactID !== this.state.assignedContactID) ? true : false,
            ismanualHandledModal: (leadDetails.is_handled === "yes" && assignType === "manual" && this.state.currentContactID && currentContactID !== this.state.currentGymOwnerID) ? true : false,
            is_handled_by: leadDetails.is_handled === "yes" ? leadDetails.handled_by : '',
            usesNewCalendar: leadDetails.usesNewCalendar ? leadDetails.usesNewCalendar : 'no',
            follow_up: leadDetails.follow_up === "0" ? false : true,
          });

          this.setState({
            currentContactID: currentContactID,
            currentGymOwnerID: currentGymOwnerID,
          });
          //get lead messages
          this.getMessages(offsetdata, 'scrolltobottom', currentContactID, currentGymOwnerID);
          //get suggested times
          this.getSuggestedTimes(moment(results.response.data.owner_timezone_array).format('YYYY-MM-DD'))
          //get other data
          setTimeout(
            function () {
              this.iframeAcuity(currentContactID, currentGymOwnerID);
              this.getShortCode(currentContactID, currentGymOwnerID);
              this.getMostUsedShortcode(currentContactID, currentGymOwnerID);
              this.getTimezone(currentContactID, currentGymOwnerID);
            }.bind(this),
            1000
          );
          if (assignType === 'auto') {
            clearInterval(idleInterval);
            clearInterval(activityInterval);
            this.countDownActivity(parseInt(this.state.activityTimeLeft));
          }
          else {
            clearInterval(idleInterval);
            this.checkIdleTime();
          }

          if (this.state.isAutoAssigned && parseInt(this.state.currentContactID) === parseInt(this.state.assignedContactID)) {
            localStorage.setItem("autoAssignInfo", JSON.stringify({
              'assignedContactID': this.state.assignedContactID,
              'assignedContactName': leadDetails.contact_name,
              'assignedGymOwnerID': this.state.assignedGymOwnerID,
              'assignedGymOwnerName': leadDetails.owner_name,
            }))
          }

          document.getElementById("message_chat_type_area").value = "";
          document.getElementById("message_chat_type_area").focus();
        }
        else {
          this.setCurrentContact('', '');
          this.setState({
            currentContactID: '',
            currentGymOwnerID: '',
            rightContainerType: 'autoAssign',
            autoAssignStartTime: Date.now(),
          });
          this.props.setLeadProcessStatus("done");
        }
      });
    }
  }

  countDownActivity = (activityTimeLeftStart = IDLE_SESSION_TIMEOUT) => {
    this.setState({
      activityTimeLeft: activityTimeLeftStart
    }, () => {
      activityInterval = setInterval(() => {
        let activityMaxTime = this.state.activityMaxTime;
        let activityTimeLeft = this.state.activityTimeLeft;
        let activityTimeHalf = activityMaxTime / 2;
        let userdata = JSON.parse(GET_STORAGE("plu"));
        if (!userdata) {
          clearInterval(activityInterval);
          clearInterval(idleInterval);
        }
        if (activityTimeLeft > 0 && userdata) {
          this.setState({
            activityTimeLeft: activityTimeLeft - 1000,
          }, () => {
            localStorage.setItem("activityTimeLeft", parseInt(this.state.activityTimeLeft));
          })
        }
        else if (parseInt(activityTimeLeft) === 0) {
          this.stopactivity();
          clearInterval(activityInterval);
          clearInterval(idleInterval);
          setTimeout(() => {
            localStorage.setItem("activityTimeLeft", IDLE_SESSION_TIMEOUT);
          }, 100)
        }
        else {
          this.setState({
            activityTimeLeft: 0,
          }, () => {
            this.stopactivity();
            clearInterval(activityInterval);
            clearInterval(idleInterval);
            setTimeout(() => {
              localStorage.setItem("activityTimeLeft", IDLE_SESSION_TIMEOUT);
            }, 100)
          })
        }
        if (activityTimeLeft === activityTimeHalf) {
          toast.info("You have an auto assigned lead on hold, It may lead to release the lead!", { autoClose: 3000, position: "top-center", });
        }
      }, 1000)
    })
  }

  checkIdleTime = (idleTimeLeftStart = IDLE_SESSION_TIMEOUT) => {
    this.setState({
      idleTimeLeft: idleTimeLeftStart
    }, () => {
      idleInterval = setInterval(() => {
        let userdata = JSON.parse(GET_STORAGE("plu"));
        let idleMaxTime = this.state.idleMaxTime;
        let idleTimeLeft = this.state.idleTimeLeft;
        // console.log("idleTimeLeft", idleTimeLeft)
        let idleTimeHalf = idleMaxTime / 2;
        if (!userdata) {
          clearInterval(idleInterval);
          clearInterval(activityInterval);
        }
        if (idleTimeLeft > 0 && userdata) {
          this.setState({
            idleTimeLeft: idleTimeLeft - 1000,
          }, () => {
            localStorage.setItem("idleTimeLeft", idleTimeLeft);
          })
        }
        else if (idleTimeLeft === 0) {
          if (!this.state.isAutoAssigned) {
            clearInterval(activityInterval);
            clearInterval(idleInterval);
            this.stopactivity();
          }
        }
        else {
          if (!this.state.isAutoAssigned) {
            clearInterval(activityInterval);
            clearInterval(idleInterval);
            this.stopactivity();
          }
        }
        if (idleTimeLeft === idleTimeHalf && !this.state.isAutoAssigned) {
          toast.info("You are not active, It may lead to logout!", { autoClose: 3000, position: "top-center", });
        }
      }, 1000);
    })
  }

  stopactivity = () => {
    if (this.state.logoutUser === 1) {
      this.setState({ logoutUser: 2 });
      toast.success("You have been logged from the system.", { autoClose: 3000 });
      this.releaseConversation(false, "yes", false, true);
      clearInterval(this.activityInterval);

      var element = document.getElementById('logoutUser');
      if (typeof (element) !== 'undefined' && element !== null) {
        document.getElementById("logoutUser").click();
      }
    }
  }

  checkNewMessage = () => {
    if (this.state.currentContactID !== '' && this.state.lastMessageId !== '') {
      clearInterval(this.interval);
      if (this.state.Socket) {
        this.interval = setInterval(() => {
          this.state.Socket.emit('checkNewMessage', this.state.currentContactID, this.state.lastMessageId);
        }, 1000);
      }
    }
  }

  newMessageFound = () => {
    if (this.state.Socket) {
      this.state.Socket.on('newMessageFound', (messageCount) => {
        if (messageCount > 0) {
          this.setState({
            leadNewMessageFound: true,
          });
        }
      });
    }

  }

  getMessages = (offsetdata = this.state.offset, scrollid = '', currentContactID, currentGymOwnerID, isFullStory = "no") => {
    let data = {
      user_id: currentGymOwnerID,
      contact_id: currentContactID,
      offset: offsetdata,
    };

    if (isFullStory === "yes") {
      data.is_full_story = isFullStory;
      data.last_full_storytime = this.state.lastFullStoryTime;
    }

    // console.log('get message call: ', data);

    clearInterval(this.interval);

    AJAX_REQUEST("POST", "v2/operator/getMessages", data).then((results) => {

      // Sentry Log create
      sentryErrorLog(results);

      if (parseInt(results.response.code) === 1000) {
        let offset = this.state.offset;

        // set lastMessageId and call socket
        if (offsetdata === 0) {
          offset = 0;
          const lastMessage = results.response.data.messages[0];
          if (lastMessage && lastMessage.hasOwnProperty('id') && lastMessage.id !== '') {
            this.setState({
              lastMessageId: lastMessage.id,
              messageLoading: false,
            });
            this.checkNewMessage();
          }
        }

        if (results.response.data.hasmore) {
          if (offsetdata === 0) {
            offset = 10;
          }
          else {
            offset += 10;
          }
        }
        let old_conversation_list = [];
        if (offsetdata !== 0) {
          old_conversation_list = this.state.messages;
        }
        let added_conversation_list = results.response.data.messages,
          new_conversation_list = Object.values(old_conversation_list.concat(added_conversation_list).reduce((r, o) => {
            r[o.id] = o;
            return r;
          }, {}));

        this.setState({
          activityLoading: false,
          message_loading: false,
          messages: new_conversation_list,
          offset: offset,
          hasmore: results.response.data.hasmore,
          leadNewMessageFound: false,
        });

        if(results.response.data.action && results.response.data.action === 'archive'){
          this.setState({
            currentContactID: false,
            assignedContactID: false,
            assignedGymOwnerID: '',
          });
          toast.success("Lead's messages were archived automatically by ALAN", { autoClose: 3000 });
          localStorage.setItem("activityTimeLeft", IDLE_SESSION_TIMEOUT);
          this.leadProcessDone();
          clearInterval(idleInterval);
          localStorage.setItem("user_id", "");
          localStorage.setItem("contact_id", "");
          this.props.setfullstory("hide");
        }

        if (isFullStory === "yes") {
          this.setState({
            lastFullStoryTime: results.response.data.last_full_storytime
          })
        }

        if (scrollid) {
          if (scrollid === "scrolltobottom") {
            setTimeout(() => {
              this.messageScrollbars.current && this.messageScrollbars.current.scrollToBottom();
            }, 10);
          }
          if (scrollid === "target_id") {
            if (results.response.data.messages.length > 0) {
              const chatIndex = added_conversation_list[0];
              const createdId = "mid-" + chatIndex.id;

              setTimeout(
                function () {
                  if (document.getElementById(createdId)) {
                    document.getElementById(createdId).scrollIntoView();
                  }
                }, 100
              );
            }
          }
        }

      } else {
        this.setState({
          activityLoading: false,
          message_loading: false,
          errorMsg: results.response.message,
          hasmore: false,
        });
      }
    });
  }

  suggestedDatepickerOpen = (status) => {
    this.setState({
      suggestedDatepickerOpen: status
    })
  }

  setSuggestedDate = (data) => {
    this.getSuggestedTimes(moment(data._d).format('YYYY-MM-DD'));
  }

  getSuggestedTimes = (day_of_week) => {
    this.setState({
      suggestedDatepickerOpen: false,
      setSuggestedDate: day_of_week,
      suggestedTimesLoading: true,
      scrollbarMaxHeight: '90%',
    })
    const data = {
      user_id: this.state.currentGymOwnerID,
      day_of_week: day_of_week
    };

    AJAX_REQUEST("POST", "operator/getSuggestedTimes", data).then((results) => {

      // Sentry Log create
      sentryErrorLog(results);

      if (parseInt(results.response.code) === 1000) {
        const data = results.response.data;

        this.setState({
          suggestedTimes: data,
          suggestedDatepickerOpen: false,
          setSuggestedDate: day_of_week,
          suggestedTimesLoading: false,
        });

        // Reset scrollbar height
        const suggestedTimesHeight = Number($(".suggestedTimes").height());
        $('.suggestedTimes').css({ height: 'auto', top: '-' + (suggestedTimesHeight + 10) + 'px' });

        if (data.length > 0) {
          setTimeout(function () {
            const suggestedTimesHeight2 = Number($(".suggestedTimes").height());
            const cusScrollbarsHeight = $('.CusScrollbars').height() - (Number(suggestedTimesHeight2) + 20);
            this.setState({ scrollbarMaxHeight: cusScrollbarsHeight })
          }.bind(this), 200)
        }


      } else {
      }
    });
  }


  iframeAcuity = (currentContactID, currentGymOwnerID) => {
    const user_data = {
      user_id: currentGymOwnerID,
      contact_id: currentContactID,
    };
    AJAX_REQUEST("POST", "operator/getAcuityCalendar", user_data).then((results) => {

      // Sentry Log create 
      sentryErrorLog(results);

      if (parseInt(results.response.code) === 1000) {
        let url_data = results.response.data.acuity_url;
        let queryString = url_data;
        let urlParams = new URLSearchParams(queryString);
        let appointmentType = urlParams.get('appointmentType');
        if (appointmentType === 0) {
          toast.error("Acuity Calendar Not Available!", { autoClose: 3000 });
          this.setState({
            acuityurl: '',
            showIframe: true,
            acuityCalendarLoading: false,
          });
        } else {
          if (results.response.data.contact_firstname) {
            url_data += '&firstName=' + results.response.data.contact_firstname;
          }
          if (results.response.data.contact_lastname) {
            url_data += '&lastName=' + results.response.data.contact_lastname;
          }
          if (results.response.data.contact_email) {
            url_data += '&email=' + results.response.data.contact_email;
          }
          if (results.response.data.contact_phone) {
            url_data += '&phone=' + results.response.data.contact_phone;
          }
          this.setState({
            acuityurl: url_data + '#dates-and-times',
            showIframe: true,
            acuityCalendarLoading: false,
          });
        }
      } else {
        this.setState({
          acuityCalendarLoading: false,
        });
        toast.error("Acuity Calendar Not Available!", { autoClose: 3000 });
      }
    });
  }

  getShortCode = (currentContactID, currentGymOwnerID) => {
    if (currentGymOwnerID === "") {
      this.setState({
        shortCodeList: [],
      });
    } else {
      this.setState({
        shortCodeLoading: true,
        errorShortCodeMessage: "",
      });
      const data = {
        user_id: parseInt(currentGymOwnerID),
        contact_id: parseInt(currentContactID),
      };
      AJAX_REQUEST("POST", "operator/getCustomFields", data).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          this.setState({
            shortCodeLoading: false,
            shortCodeList: results.response.data,
          });
        } else {
          this.setState({
            shortCodeLoading: false,
            errorShortCodeMessage: results.response.message,
          });
        }
      });
    }
  };

  getMostUsedShortcode = (currentContactID, currentGymOwnerID) => {
    if (currentGymOwnerID === "") {
      this.setState({
        mostUsedShortCodeList: [],
      });
    } else {
      this.setState({
        mostUsedShortcodeLoading: true,
        errorMostUsedShortCodeMessage: "",
      });
      const data = {
        business_owner_id: parseInt(currentGymOwnerID),
        contact_id: parseInt(currentContactID),
      };
      AJAX_REQUEST("POST", "operator/getMostUsedShortCodes", data).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          this.setState({
            mostUsedShortcodeLoading: false,
            mostUsedShortCodeList: results.response.data,
          });
        } else {
          this.setState({
            mostUsedShortcodeLoading: false,
            errorMostUsedShortCodeMessage: results.response.message,
          });
        }
      }
      );
    }
  };

  getTimezone = (currentContactID = '', currentGymOwnerID = '') => {
    const data = {
      user_id: parseInt(currentGymOwnerID ? currentGymOwnerID : this.state.currentGymOwnerID),
      contact_id: parseInt(currentContactID ? currentContactID : this.state.currentContactID),
    };
    AJAX_REQUEST("POST", "operator/getTimezone", data).then((results) => {

      // Sentry Log create
      sentryErrorLog(results);

      if (parseInt(results.response.code) === 1000) {
        this.setState({
          owner_timezone_array: results.response.data.owner_timezone_array
        });
      } else {
        toast.error(results.response.message, { autoClose: 3000 });
      }
    });
  }

  handleScrollStop = () => {
    if (this.messageScrollbars.current) {
      if (this.messageScrollbars.current.viewScrollTop === 0) {
        if (!this.state.message_loading) {
          if (this.state.hasmore) {
            this.setState({ message_loading: true });
            if (this.props.isFullStory === "yes") {
              this.getMessages(this.state.offset, "target_id", this.state.currentContactID, this.state.currentGymOwnerID, "yes");
            }
            else {
              this.getMessages(this.state.offset, "target_id", this.state.currentContactID, this.state.currentGymOwnerID);
            }
          }
        }
      }
    }
  };

  checkShortcodeAvailability = () => {
    let value = document.getElementById("message_chat_type_area").value;
    let typed_shortcodes_str = [];
    typed_shortcodes_str = value.match(/\[[^\]]*]/g);
    let typed_shortcodes_arr = [];
    let shortcode_arr = [];
    let typed_shortcodes_has = [];
    let rt_val = [true];

    if (typed_shortcodes_str) {
      if (this.state.shortCodeList) {
        this.state.shortCodeList.map(async (single_shortcode, index) => {
          single_shortcode.fields.map((val, ind) => {
            shortcode_arr.push(val.field_name);
            return true;
          });
          return true;
        });
      }
      typed_shortcodes_str.map((typed_single, index) => {
        let each_val = typed_single.replace(/[[\]]/g, '');
        typed_shortcodes_arr[index] = each_val;
        typed_shortcodes_has[index] = shortcode_arr.includes(each_val);
        if (shortcode_arr.includes(each_val) === false) {
          toast.info(`Your typed Shortcode [${each_val}] doesn't exist in this leads shortcode list!`, { autoClose: 3000 });
          rt_val.push(false);
        }
        else {
          rt_val.push(true);
        }
        return true;
      });
    } else {
      rt_val.push(true);
    }
    return rt_val;
  }

  chooseHour = (status) => {
    this.setState({
      chooseHour: status
    });
    if (status) {
      document.querySelector(".flatpickerDiv .flatpickr-time").classList.add("d-none");
    }
    else {
      document.querySelector(".flatpickerDiv .flatpickr-time").classList.remove("d-none");
    }
  }

  chooseMinute = (status) => {
    this.setState({
      chooseMinute: status
    });
    if (status) {
      document.querySelector(".flatpickerDiv .flatpickr-time").classList.add("d-none");
    }
    else {
      document.querySelector(".flatpickerDiv .flatpickr-time").classList.remove("d-none");
    }
  }

  selectHour = (e, hour) => {
    e.preventDefault();
    let timed = moment(this.state.schedule_date_time ? this.state.schedule_date_time : '').format("YYYY-MM-DD HH:mm:ss");
    let dateStr = moment(timed).format("YYYY-MM-DD"),
      timeStr = moment(timed).format("HH:mm:ss"),
      date = moment(dateStr),
      time = moment(timeStr, 'HH:mm:ss'),
      ampm = moment(timed).format("A");
    let hourset = hour;
    if (ampm === "PM") {
      hourset = parseInt(hour) + 12;
    }
    date.set({
      hour: hourset,
      minute: time.get('minute'),
      second: 0
    });

    let newdate = moment(date).format("YYYY-MM-DD HH:mm:ss");
    this.setScheduleDate(newdate);
    this.chooseHour(false);
    document.querySelector(".numInput.flatpickr-hour").value = hour;
    setTimeout((e) => {
      var element = document.querySelector('.flatpickr-am-pm');
      this.simulateMouseClick(element);
    }, 200);
  }

  selectMinute = (e, minute) => {
    e.preventDefault();
    let timed = moment(this.state.schedule_date_time ? this.state.schedule_date_time : '').format("YYYY-MM-DD HH:mm:ss");
    let dateStr = moment(timed).format("YYYY-MM-DD"),
      timeStr = moment(timed).format("HH:mm:ss"),
      date = moment(dateStr),
      time = moment(timeStr, 'HH:mm:ss');

    date.set({
      hour: time.get('hour'),
      minute: minute,
      second: 0
    });

    let newdate = moment(date).format("YYYY-MM-DD HH:mm:ss");

    this.setScheduleDate(newdate);
    this.chooseMinute(false);
    document.querySelector(".numInput.flatpickr-minute").value = minute;
    setTimeout((e) => {
      var element = document.querySelector('.flatpickr-am-pm');
      this.simulateMouseClick(element);
      this.simulateMouseClick(element);
    }, 200);
  }

  simulateMouseClick = (targetNode) => {
    function triggerMouseEvent(targetNode, eventType) {
      var clickEvent = document.createEvent('MouseEvents');
      clickEvent.initEvent(eventType, true, true);
      targetNode.dispatchEvent(clickEvent);
    }
    ["mouseover", "mousedown", "mouseup", "click"].forEach(function (eventType) {
      triggerMouseEvent(targetNode, eventType);
    });
  }

  typeMessage = (e, show_alert = true) => {
    let value = document.getElementById("message_chat_type_area").value;
    let typed_shortcodes_str = [];
    typed_shortcodes_str = value.match(/\[[^\]]*]/g);
    let typed_shortcodes_arr = [];
    let shortcode_arr = [];
    let typed_shortcodes_has = [];

    if (typed_shortcodes_str) {
      if (this.state.shortCodeList) {
        this.state.shortCodeList.map((single_shortcode, index) => {
          single_shortcode.fields.map((val, ind) => {
            shortcode_arr.push(val.field_name);
            return true;
          });
          return true;
        });
      }
      typed_shortcodes_str.map((typed_single, index) => {
        let each_val = typed_single.replace(/[[\]]/g, '');
        typed_shortcodes_arr[index] = each_val;
        typed_shortcodes_has[index] = shortcode_arr.includes(each_val);
        if (shortcode_arr.includes(each_val) === false) {
          if (show_alert === true) {
            toast.info(`Your typed Shortcode [${each_val}] doesn't exist in this leads shortcode list!`, { autoClose: 3000 });
          }
          setTimeout(() => {
            let new_val = value.replace(`[${each_val}]`, '');
            document.getElementById("message_chat_type_area").value = new_val;
          }, 2000);
        }
        return true;
      });
    }
  };

  keyUpTrigger = (e, send_type = "sent") => {
    let value = document.getElementById("message_chat_type_area").value;
    const shortcode_valid = this.checkShortcodeAvailability();
    if (shortcode_valid.includes(false)) {
      return false;
    }
    if (shortcode_valid) {
      if (value.trim().length > 0) {
        this.keyUpTriggerSendMessage(send_type);
      }
    }
  }

  keyUpTriggerSendMessage = (send_type = 'sent') => {
    let value = document.getElementById("message_chat_type_area").value;
    if (value.trim().length > 0) {
      this.onMessageSubmit(send_type);
    }
  };

  sendMessage = (e, send_type = 'sent') => {
    e.preventDefault();
    let value = document.getElementById("message_chat_type_area").value;
    if (value.trim().length > 0) {
      const shortcode_valid = this.checkShortcodeAvailability();
      if (shortcode_valid.includes(false)) {
        return false;
      }
      this.onMessageSubmit(send_type);
    }
  };

  onMessageSubmit = (send_type = 'sent') => {
    let value = document.getElementById("message_chat_type_area").value;
    this.setState({ message_sending_loading: true });
    let message = {
      contact_id: this.state.currentContactID,
      user_id: this.state.currentGymOwnerID,
      message_text: value.trim(),
      message_send: 1,
      app_version: 2,
      sent_type: send_type
    };

    AJAX_REQUEST("POST", "operator/send_message", message).then((results) => {

      // Sentry Log create
      sentryErrorLog(results);

      if (parseInt(results.response.code) === 1000) {
        this.setState({ hide_message_area: true });
        let messagetype = results.response.data.status ? results.response.data.status : 'success';
        if (messagetype === 'success') {
          toast.success(results.response.data.message, { autoClose: 3000 });
        }
        else {
          toast.error(results.response.data.message, { autoClose: 3000 });
        }

        // call lead process done function
        this.leadProcessDone();
        this.props.setReloadReply(true);

      } else {
        toast.error(results.response.message, { autoClose: 3000 });
        this.setState({ message_sending_loading: false });
      }
    });
  }

  openLightboxNow = (media_url) => {
    this.setState({
      urlToLargeImageFile: media_url,
      urlToHugeImageFile: media_url,
      alt: '',
      openLightbox: true,
    });
  }

  closeLightbox = () => {
    this.setState({ openLightbox: false });
  };

  leadActionModal = (leadActionType = '') => {

    let leadActionModalTitle, leadActionModalBody = '';

    if (leadActionType === 'chat_archive') {
      leadActionModalTitle = 'Archive Lead';
      leadActionModalBody = '<span>Are you sure,</span> you want to Archive this lead?';
    } else if (leadActionType === 'optout') {
      leadActionModalTitle = 'Opt Out Lead';
      leadActionModalBody = '<span>Are you sure,</span> you want to Opt Out this lead?';
    } else if (leadActionType === 'blacklist') {
      leadActionModalTitle = 'Black List';
      leadActionModalBody = '<span>Are you sure,</span> you want to Black List this lead?';
    } else if (leadActionType === 'assign_to_gymowner') {
      leadActionModalTitle = 'Assign to Owner';
      leadActionModalBody = '<span>Are you sure,</span> you want to Assign this conversation to Owner?';
    } else if (leadActionType === 'follow_up') {
      leadActionModalTitle = 'Snooze';
      leadActionModalBody = '<span>Are you sure,</span> you want to snooze this lead for later?';
    } else if (leadActionType === "unfollow_up") {
      leadActionModalTitle = 'Unsnooze';
      leadActionModalBody = '<span>Are you sure,</span> you want to Unsnooze this lead?';
    } else if (leadActionType === 'escalate') {
      leadActionModalTitle = 'Escalate';
      leadActionModalBody = '<span>Are you sure,</span> you want to escalate this conversation?';
    }

    this.setState({
      leadActionModalDisplay: !this.state.leadActionModalDisplay,
      leadActionType: leadActionType,
      leadActionModalTitle,
      leadActionModalBody,
      pleaseWait: false,
    });
  }

  leadAction = () => {
    this.setState({ pleaseWait: true }, () => {

      const data = {
        user_id: parseInt(this.state.currentGymOwnerID),
        contact_id: parseInt(this.state.currentContactID),
        action: this.state.leadActionType,
      };

      AJAX_REQUEST("POST", "v2/operator/leadAction", data).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          toast.success(results.response.message, { autoClose: 3000 });

          if (this.state.leadActionType === 'chat_archive') {
            this.setState({ is_archived: "yes" });
          } else if (this.state.leadActionType === 'optout') {
            this.setState({ opt_out: "yes" });
          } else if (this.state.leadActionType === 'blacklist') {
            this.setState({ blacklist: "yes" });
          } else if (this.state.leadActionType === 'assign_to_gymowner') {
            this.setState({ is_assigned_to_gymowner: "yes" });
          } else if (this.state.leadActionType === 'escalate') {
            this.setState({ is_assigned_to_admin: "yes" });
          } else if (this.state.leadActionType === 'follow_up') {
            this.setState({ follow_up: true });
          } else if (this.state.leadActionType === 'unfollow_up') {
            this.setState({ follow_up: false });
          }

          this.leadActionModal();
          localStorage.setItem("activityTimeLeft", IDLE_SESSION_TIMEOUT);

          // call lead process done function
          this.leadProcessDone();
        } else {
          toast.error(results.response.message, { autoClose: 3000 });
          this.leadActionModal();
        }

      });

    });
  }

  leadScheduleActionModal = (actionType = '') => {

    this.setState({ pleaseWait: false });

    if (actionType === 'newSchedule') {
      this.setState({ addScheduleModalShow: !this.state.addScheduleModalShow });
      this.getTimezone();
    } else if (actionType === 'reSchedule') {

      const data = {
        user_id: parseInt(this.state.currentGymOwnerID),
        event_id: parseInt(this.state.schedule_id),
      };
      AJAX_REQUEST("POST", "operator/getAlanCalendarEventDetails", data).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          this.setState({
            reScheduleModalShow: !this.state.reScheduleModalShow,
            scheduleDateRange: results.response.data.appointment.schedule_date,
            scheduleTimeRange: results.response.data.appointment.schedule_time,
          });
        } else {
          toast.error(results.response.message, { autoClose: 3000 });
        }
      });

      this.getTimezone();

    } else if (actionType === 'cancelSchedule') {
      this.setState({ cancelScheduleModalShow: !this.state.cancelScheduleModalShow });
    }

    if (!this.state.pleaseWait) {
      this.setState({
        chooseHour: false,
        chooseMinute: false
      });
      setTimeout(() => {
        let hourexists = document.querySelector(".numInput.flatpickr-hour");
        if (hourexists) {
          document.querySelector(".numInput.flatpickr-hour").addEventListener("click", function () {
            this.chooseHour(true);
          }.bind(this));
        }
        let minuteexists = document.querySelector(".numInput.flatpickr-minute");
        if (minuteexists) {
          document.querySelector(".numInput.flatpickr-minute").addEventListener("click", function () {
            this.chooseMinute(true);
          }.bind(this));
        }
      }, 1000)

    }

  }

  leadScheduleAction = (actionType = '') => {
    this.setState({ pleaseWait: true }, () => {

      let data = {
        user_id: parseInt(this.state.currentGymOwnerID),
        contact_id: parseInt(this.state.currentContactID),
      };

      let apiEndPoin = '';
      if (actionType === 'newSchedule') {
        apiEndPoin = 'newSchedule';
        data.datetime = moment(this.state.schedule_date_time ? this.state.schedule_date_time : '').format("YYYY-MM-DD H:mm:ss");
        data.app_version = 2;
      } else if (actionType === 'reSchedule') {
        apiEndPoin = 'editSchedule';
        data.schedule_id = parseInt(this.state.schedule_id);
        data.datetime = moment(this.state.schedule_date_time ? this.state.schedule_date_time : '').format("YYYY-MM-DD H:mm:ss");
        data.app_version = 2;
      } else if (actionType === 'cancelSchedule') {
        apiEndPoin = 'cancelAppointment';
        data.event_id = parseInt(this.state.schedule_id);
      }

      AJAX_REQUEST("POST", "v2/operator/" + apiEndPoin, data).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          toast.success(results.response.message, { autoClose: 3000 });
          this.leadScheduleActionModal(actionType);

          if (actionType === 'newSchedule' || actionType === 'reSchedule') {
            this.setState({ is_scheduled: "yes" }, () => {
              this.props.newSelectedPlay();
            })
          } else if (actionType === 'cancelSchedule') {
            this.setState({
              is_scheduled: "no",
              schedule_id: "",
            });
          }

          // call lead process done function
          this.leadProcessDone();
        } else {
          toast.error(results.response.message, { autoClose: 3000 });
          this.setState({ pleaseWait: false });
        }
      });


    })
  }

  setScheduleDate = (date) => {
    this.setState({
      schedule_date_time: moment(date).format("YYYY-MM-DD HH:mm:ss")
    })
  }

  releaseConversation = (visibleStatus, isConfirmed = "no", showToastr = true, loggedOut = false) => {
    this.setState({
      releaseConversationShow: visibleStatus,
      pleaseWait: false
    });

    if (isConfirmed === "yes") {
      this.setState({ pleaseWait: true });
      const data = {
        user_id: parseInt(this.state.assignedGymOwnerID),
        contact_id: parseInt(this.state.assignedContactID),
        is_auto_assigned: "yes",
        logged_out: loggedOut ? loggedOut : false
      };

      AJAX_REQUEST("POST", "operator/releaseSession", data).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          if (showToastr) {
            toast.success(results.response.message, { autoClose: 3000 });
          }
          this.setState({
            pleaseWait: false,
            releaseConversationShow: false,
          });
          if (!loggedOut) {
            localStorage.setItem("activityTimeLeft", IDLE_SESSION_TIMEOUT);
            this.leadProcessDone();
          }
          clearInterval(idleInterval);
          this.setState({
            assignedContactID: '',
            assignedGymOwnerID: '',
          })
          localStorage.setItem("user_id", "");
          localStorage.setItem("contact_id", "");
          this.props.setfullstory("hide");
          // Socket Auto Assign Search Ends
        } else {
          if (showToastr) {
            toast.error(results.response.message, { autoClose: 3000 });
          }
          this.setState({ pleaseWait: false, });
        }
      });
    }
  };

  conversationReleaseModal = (visibleStatus) => {
    this.setState({ conversationReleaseModalShow: visibleStatus });
  };

  contactIsLiveModal = (visibleStatus) => {
    this.setState({
      contactIsLiveModal: visibleStatus
    })
  }

  notAssignedtoYouModal = (visibleStatus) => {
    this.setState({
      notAssignedtoYou: visibleStatus
    }, () => {
      if (!visibleStatus) {
        this.setCurrentContact('', '');
        this.setState({
          current_contact: '',
          current_gym_owner: '',
          last_autoassigned_contact: '',
          last_autoassigned_gym_owner: '',
          rightContainerType: 'autoAssign',
          autoAssignStartTime: Date.now(),
        })
      }
    })
  }

  leadProcessDone = () => {
    //check last auto assigned lead, if found then load

    // console.log('leadProcessDone call')

    //else search lead
    this.setState({
      currentContactID: '',
      currentGymOwnerID: '',
      rightContainerType: 'autoAssign',
      autoAssignStartTime: Date.now(),
    });

    if (this.state.isAutoAssigned) {
      localStorage.setItem("autoAssignInfo", JSON.stringify({}));

      this.setState({
        activityTimeLeft: 0,
      }, () => {
        clearInterval(activityInterval);
        clearInterval(idleInterval);
        localStorage.setItem("activityTimeLeft", IDLE_SESSION_TIMEOUT);
      })

    }
    this.props.setLeadProcessStatus("done");
  }

  render() {

    // for auto assign area
    let getRoundedDate = (minutes, d) => {
      let ms = 1000 * 60 * minutes; // convert minutes to ms
      let roundedDate = new Date(Math.ceil(d.getTime() / ms) * ms);
      return roundedDate;
    }

    let datetimeround = getRoundedDate(5, this.state.owner_timezone_array ? (this.state.owner_timezone_array.date ? new Date(this.state.owner_timezone_array.date) : '') : new Date());
    let date = datetimeround;

    let validday = Datetime.moment(date).subtract(1, 'day');
    let valid = function (current) {
      return current.isAfter(validday);
    };

    const autoAssignInfo = (localStorage.getItem("autoAssignInfo")) ? JSON.parse(localStorage.getItem("autoAssignInfo")) : [];
    const assignedContactName = (autoAssignInfo) ? autoAssignInfo.assignedContactName : '';
    const assignedGymOwnerName = (autoAssignInfo) ? autoAssignInfo.assignedGymOwnerName : '';

    // console.log('render currentContactID conversations', this.state.currentContactID);

    return (

      this.state.currentContactID ?
        <Fragment>
          {/* image lightbox */}
          {
            this.state.openLightbox && (
              <Lightbox
                medium={this.state.urlToLargeImageFile}
                large={this.state.urlToHugeImageFile}
                alt={this.state.alt}
                onClose={this.closeLightbox}
              />
            )
          }

          <div className="main-chat-container">
            {this.state.activityLoading ? (
              <div className="loading">
                <FontAwesomeIcon icon={faIcon.faSyncAlt} />
              </div>
            ) : (
              <Fragment>
                {
                  (this.state.assignedContactID && this.state.assignedContactID !== '' && parseInt(this.state.assignedContactID) !== parseInt(this.state.currentContactID)) ?
                    <div className="showAutoonManual" onClick={() => { this.setCurrentContact(this.state.assignedContactID, this.state.assignedGymOwnerID, 'auto'); this.props.setfullstory('no'); }}>
                      <div className="idleBar" style={{ width: (parseInt(this.state.activityTimeLeft) / parseInt(this.state.activityMaxTime)) * 100 + '%' }}></div>
                      You have an <strong>Assigned Live Lead</strong>: <FontAwesomeIcon icon={faIcon.faBriefcase} /> {assignedGymOwnerName}
                      <FontAwesomeIcon className="ml-1" icon={faIcon.faUser} /> {assignedContactName}
                    </div>
                    : ''
                }
                <div className={'main-chat-top-header ' + (((this.state.isAutoAssigned) && ((this.state.assignedContactID === this.state.currentContactID))) ? 'LiveAssigned' : 'manuallyAssigned')}>
                  <div className="live-chat-custome-owner">
                    <div className="customer-name">
                      <div className="icon">
                        <FontAwesomeIcon icon={faIcon.faUser} /> &nbsp;
                      </div>
                      <div className="">
                        <h3>
                          <span className="contact_name_message" title={this.state.contact_name}>{this.state.contact_name}</span>
                          {
                            (this.state.is_handled === 'yes' && !(this.state.isAutoAssigned)) ?
                              <RBT.OverlayTrigger
                                placement={"right"}
                                overlay={<Tooltip>{this.state.is_handled_by + " is handling this lead"} </Tooltip>}
                              >
                                <RBT.Nav.Link href="#" className="text-danger ishandled">
                                  <FontAwesomeIcon icon={faIcon.faUserLock} />
                                </RBT.Nav.Link>
                              </RBT.OverlayTrigger>
                              :
                              ''
                          }
                          {
                            ((this.state.isAutoAssigned) && ((this.state.assignedContactID === this.state.currentContactID))) ?
                              <Timer
                                initialTime={parseInt(this.state.activityMaxTime) - parseInt(this.state.activityTimeLeft)}
                                startImmediately={true}
                                onStart={() => console.log("onStart hook")}
                                onResume={() => console.log("onResume hook")}
                                onPause={() => console.log("onPause hook")}
                                onStop={() => console.log("onStop hook")}
                                onReset={() => console.log("onReset hook")}
                                formatValue={(value) => `${value < 10 ? `0${value}` : value}`}
                              >
                                {({ start, resume, pause, stop, reset, timerState }) => (
                                  <React.Fragment>
                                    <span className="idly-time">
                                      <FontAwesomeIcon icon={faIcon.faClock} />
                                      <Timer.Minutes />:<Timer.Seconds />
                                    </span>
                                    <span className="d-none" id="resetClock" onClick={reset}>
                                      Reset
                                    </span>
                                  </React.Fragment>
                                )}
                              </Timer>
                              :
                              ''
                          }
                          {
                            (((this.state.isAutoAssigned) && ((this.state.assignedContactID === this.state.currentContactID)))) ?
                              <button className="release-btn btn btn-sm btn-danger" onClick={() => this.releaseConversation(true, "no")}>
                                Release Session
                              </button>
                              :
                              ''
                          }
                        </h3>
                        <span className="promo-name" title={this.state.promo_name}> {this.state.promo_name}</span>
                        <div className="gym-martial-arts" title={this.state.cat_campaign_title + ' - ' + this.state.sub_cat_campaign_title}>
                          {" "}
                          {this.state.cat_campaign_title} - {this.state.sub_cat_campaign_title}
                        </div>

                      </div>

                    </div>
                    <div className="gym-owner-name" onClick={() => this.conversationReleaseModal(false)}>
                      <FontAwesomeIcon icon={faIcon.faBriefcase} /> &nbsp;
                      {this.state.owner_name}
                    </div>

                  </div>
                </div>
                <div className="main-chat-header">
                  <h3 className="date-time">
                    {this.state.is_scheduled === "yes" ? (
                      <Fragment>
                        <FontAwesomeIcon icon={faIcon.faCalendarCheck} />
                        <span>{this.state.schedule_date_time_formatted}</span>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </h3>

                  <div className="header-btn-group">
                    <ul>
                    {this.state.usesNewCalendar === 'no' ? (
                      this.state.is_scheduled === "yes" ? (
                        <Fragment>
                          <li className="reschedule">
                            <RBT.Nav.Link href="#" id="reschedule_btn" onClick={() => this.leadScheduleActionModal('reSchedule')}>
                              {" "}
                              <FontAwesomeIcon icon={faIcon.faHistory} /> Reschedule{" "}
                            </RBT.Nav.Link>
                          </li>
                          <li className="schedule">
                            <RBT.Nav.Link href="#" id="cancel_schedule_btn" onClick={() => this.leadScheduleActionModal('cancelSchedule')}>

                              <FontAwesomeIcon icon={faIcon.faCalendarTimes} /> Cancel Schedule
                            </RBT.Nav.Link>
                          </li>
                        </Fragment>
                      ) : (
                        <li className="addschedule">
                          <RBT.Nav.Link href="#" onClick={() => this.leadScheduleActionModal('newSchedule')}>
                            {" "}
                            <FontAwesomeIcon icon={faIcon.faCalendarPlus} /> Add Schedule{" "}
                          </RBT.Nav.Link>
                        </li>
                      )
                      ) : "" }

                      {this.state.is_assigned_to_admin === "no" && this.state.can_escalate === "yes" ? (
                        <li className="assign-to-owner">
                          <RBT.Nav.Link href="#" onClick={() => this.leadActionModal('escalate')}>
                            {" "}
                            Escalate{" "}
                          </RBT.Nav.Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {this.state.is_assigned_to_gymowner === "no" && this.state.can_escalate === "no" ? (
                        <li className="assign-to-owner">
                          <RBT.Nav.Link href="#" onClick={() => this.leadActionModal('assign_to_gymowner')}>
                            {" "}
                            Assign to Owner{" "}
                          </RBT.Nav.Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {this.state.is_archived === "no" ? (
                        <li className="archive">
                          <RBT.Nav.Link href="#" onClick={() => this.leadActionModal('chat_archive')}>
                            Archive
                          </RBT.Nav.Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {this.state.opt_out === "no" ? (
                        <li className="opt-out">
                          <RBT.Nav.Link href="#" onClick={() => this.leadActionModal('optout')}>
                            Opt Out
                          </RBT.Nav.Link>
                        </li>
                      ) : (
                        ''
                      )}
                      {this.state.blacklist === "no" ? (
                        <li className="black-list">
                          <RBT.Nav.Link href="#" onClick={() => this.leadActionModal('blacklist')}>
                            Black List
                          </RBT.Nav.Link>
                        </li>
                      ) : (
                        ''
                      )}
                      {this.state.follow_up === false ? (
                        <li className="follow_up">
                          <RBT.Nav.Link href="#" id="follow_up_btn" onClick={() => this.leadActionModal('follow_up')}>
                            {" "}
                            <FontAwesomeIcon icon={faIcon.faBed} /> Snooze{" "}
                          </RBT.Nav.Link>
                        </li>
                      ) : (
                        <li className="follow_up">
                          <RBT.Nav.Link href="#" id="follow_up_btn" onClick={() => this.leadActionModal('unfollow_up')}>
                            {" "}
                            <FontAwesomeIcon icon={faIcon.faBed} /> Unsnooze{" "}
                          </RBT.Nav.Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>

                {
                  this.state.leadNewMessageFound ?
                    <div className="loading">
                      <FontAwesomeIcon icon={faIcon.faSyncAlt} />
                    </div>
                    :
                    <Scrollbars
                      renderTrackVertical={(props) => <div {...props} className="track-vertical" />}
                      renderThumbVertical={(props) => <div {...props} className="thumb-vertical" />}
                      ref={this.messageScrollbars}
                      onScrollStop={this.handleScrollStop}
                      className="CusScrollbars mainchat-box-wrapper"
                      id="message_area_scrollbar"
                      autoHeight
                      autoHeightMin={'50%'}
                      autoHeightMax={(this.state.scrollbarMaxHeight) ? this.state.scrollbarMaxHeight : '100%'}
                    >
                      {this.state.message_loading ? (
                        <div className="text-center message_popup_loading">
                          <FontAwesomeIcon icon={faIcon.faSyncAlt} />
                        </div>
                      ) : (
                        ""
                      )}

                      {this.state.messages.length > 0 ? (
                        <ul>
                          {this.state.messages.map((messages_single, index) => {
                            let msgclass = "sender";
                            const message_data = messages_single.message_text.replace(/(?:\r\n|\r|\n)/g, "<br />");
                            if (messages_single.message_status === "send") {
                              msgclass += " me";
                            }
                            else if (messages_single.message_status === "schedule") {
                              msgclass += " me schedule";
                            }
                            else if (messages_single.message_status === "reschedule") {
                              msgclass += " me reschedule";
                            }
                            else if (messages_single.message_status === "cancel_schedule") {
                              msgclass += " me cancel_schedule";
                            }
                            else if (messages_single.message_status === "assign_to_gymowner") {
                              msgclass += " me assign_to_gymowner";
                            }
                            else if (messages_single.message_status === "archive") {
                              msgclass += " me archive";
                            }
                            else if (messages_single.message_status === "opt_out") {
                              msgclass += " me opt_out";
                            }
                            else if (messages_single.message_status === "blacklist") {
                              msgclass += " me blacklist";
                            }
                            else if (messages_single.message_status === "release") {
                              msgclass += " me release";
                            }
                            else if (messages_single.message_status === "show") {
                              msgclass += " me show";
                            }
                            else if (messages_single.message_status === "not_show") {
                              msgclass += " me not_show";
                            }
                            else if (messages_single.message_status === "sold") {
                              msgclass += " me sold";
                            }
                            return (
                              <li className={msgclass} key={messages_single.id} id={`mid-${messages_single.id}`}>
                                <div className="text-container">
                                  <span className="messageSingle">{Parser(message_data)}</span>
                                  <div className={"mediaContainer " + msgclass}>
                                    {
                                      messages_single.medias ?
                                        messages_single.medias.map((media_single, index) => {
                                          if (media_single && Object.keys(media_single).length > 0 && media_single.hasOwnProperty('type') && media_single.type !== null) {
                                            if (media_single.type.includes("video")) {
                                              return <ReactPlayer key={index} className="video_media" url={media_single.converted_link} controls={true} loop={false} />;
                                            }
                                            else if (media_single.type.includes("audio")) {
                                              if (media_single.type === "audio/amr") {
                                                if (msgclass === 'sender') {
                                                  return (
                                                    <AmrPlay key={index} converted_link={media_single.converted_link} c_content="left_content" />
                                                  );
                                                } else {
                                                  return (
                                                    <AmrPlay key={index} converted_link={media_single.converted_link} c_content="right_content" />
                                                  );
                                                }
                                              }
                                              else {
                                                return <ReactPlayer key={index} className="audio_media" url={media_single.converted_link} controls={true} loop={false} />;
                                              }
                                            }
                                            else if (media_single.type.includes("image")) {
                                              return <ReactImageFallback
                                                key={index}
                                                onClick={() => this.openLightboxNow(media_single.converted_link)}
                                                src={media_single.converted_link}
                                                fallbackImage={require('../../Assets/images/preloader.gif').default}
                                                initialImage={require('../../Assets/images/preloader.gif').default}
                                                alt=""
                                                className="image_media" />
                                            }
                                          }
                                          return true;
                                        })
                                        : ''
                                    }
                                  </div>
                                  <div className="time"><span className={messages_single.message_by ? "sendBy" : ''}>{messages_single.message_by ? messages_single.message_by : ''}</span>{messages_single.created}{((messages_single.message_type === "Auto") && (messages_single.message_by === '')) ? <strong> (Auto)</strong> : ''}</div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        <div className="server-error-message">{Parser(this.state.errorMsg)}</div>
                      )}
                    </Scrollbars>
                }

                <RBT.Form className="chat-send-opt">
                  {this.state.is_scheduled === 'no' && this.state.usesNewCalendar === 'no' ?
                    <div className="col-12 suggestedTimes">
                      <strong>Suggested Times for : </strong>
                      {
                        this.state.suggestedDatepickerOpen ?
                          <FontAwesomeIcon id="closeSuggestedDatepicker" icon={faIcon.faTimesCircle} onClick={() => this.suggestedDatepickerOpen(false)} />
                          : ''
                      }
                      <Datetime
                        className="setScheduleMessagePauseDate"
                        defaultValue={datetimeround}
                        open={this.state.suggestedDatepickerOpen}
                        dateFormat="YYYY-MM-DD"
                        timeFormat={false}
                        onChange={(date) => this.setSuggestedDate(date)}
                        onFocus={() => this.suggestedDatepickerOpen(true)}
                        onBlur={() => this.suggestedDatepickerOpen(false)}
                        isValidDate={valid}
                      />
                      {
                        this.state.suggestedTimesLoading ?
                          <FontAwesomeIcon className="fa-spin" icon={faIcon.faSyncAlt} />
                          :
                          this.state.suggestedTimes.length > 0 ? (
                            this.state.suggestedTimes.map((time_single, index) => {
                              let badgeclass = "badge";
                              if (time_single.kind === "ok") {
                                badgeclass += " badge-primary";
                              }
                              else if (time_single.kind === "good") {
                                badgeclass += " badge-success";
                              }
                              else {
                                badgeclass += " badge-danger";
                              }
                              return (
                                <span className={badgeclass} key={time_single.id} id={`suggesttime-${time_single.id}`}>{time_single.time12}</span>
                              );
                            })
                          ) : (
                            <span>No Suggested Time Found!</span>
                          )}
                    </div>
                    : ''
                  }
                  {this.state.message_sending_loading ? (
                    <div className="message_sanding_loading_container">
                      <div className="loading">
                        <FontAwesomeIcon icon={faIcon.faSyncAlt} />
                      </div>
                    </div>

                  ) : (
                    <Fragment>
                      {this.state.hide_message_area || (this.state.blacklist === "yes") ? (
                        ""
                      ) : (
                        <Fragment>
                          <textarea placeholder="Type your message..."
                            id="message_chat_type_area"
                            onKeyUp={this.typeMessage}
                            autoComplete={'off'}
                            data-enable-grammarly="true"
                          >

                          </textarea>
                          <RBT.Button type="submit" onClick={this.sendMessage}>
                            {" "}
                          </RBT.Button>
                          {
                            this.state.pauseScheduleMessage ?
                              <Fragment>
                                <RBT.Button className="pauseSend" type="submit" onClick={(e) => this.sendMessage(e, 'pause_and_sent')}>
                                  {" "}
                                </RBT.Button>
                                <Hotkeys
                                  keyName="ctrl+enter,command+enter"
                                  onKeyUp={(e) => this.keyUpTrigger(e, 'pause_and_sent')}
                                  filter={(event) => {
                                    return true;
                                  }}
                                ></Hotkeys>
                              </Fragment>
                              : ''
                          }
                          <Hotkeys
                            keyName="enter"
                            onKeyUp={(e) => this.keyUpTrigger(e)}
                            filter={(event) => {
                              return true;
                            }}
                          ></Hotkeys>
                        </Fragment>
                      )}
                    </Fragment>
                  )}
                </RBT.Form>
              </Fragment>
            )}

            {/* Start conversation Release Modal */}
            <RBT.Modal
              className="live-chat-modal conversationReleaseAlert"
              centered
              show={this.state.releaseConversationShow}
              onHide={() => this.releaseConversation(false, "no")}
            >
              <RBT.Modal.Header closeButton>
                <RBT.Modal.Title>Release Session</RBT.Modal.Title>
              </RBT.Modal.Header>
              <RBT.Modal.Body>
                <div className="delete-content">
                  <div>
                    <span>Are you sure,</span> you want to Release Session for this conversation?
                    <RBT.Button disabled={this.state.pleaseWait} onClick={() => this.releaseConversation(true, "yes")}>
                      {this.state.pleaseWait ? "Releasing..." : "Yes"}
                    </RBT.Button>
                  </div>
                </div>
              </RBT.Modal.Body>
            </RBT.Modal>
            {/* End conversation Release ModalShow */}

            {/* Start notAssignedtoYou modal */}
            <RBT.Modal
              className="live-chat-modal"
              centered
              show={this.state.notAssignedtoYou}
              onHide={() => this.notAssignedtoYouModal(false)}
            >
              <RBT.Modal.Header closeButton>
                <RBT.Modal.Title>Assigned to Someone Else</RBT.Modal.Title>
              </RBT.Modal.Header>
              <RBT.Modal.Body>
                <div className="delete-content">
                  <div>
                    <span>This Lead is assigned to someone else,</span> the system has been reloaded
                    <RBT.Button onClick={() => this.notAssignedtoYouModal(false)}>
                      OK
                    </RBT.Button>
                  </div>
                </div>
              </RBT.Modal.Body>
            </RBT.Modal>
            {/* End Opt Out modal */}

            {/* Start is handled modal */}
            <RBT.Modal
              className="live-chat-modal"
              centered
              show={(!(this.state.isAutoAssigned) && (this.state.ishandledModal)) ? true : false}
              onHide={() => this.setState({ ishandledModal: false })}
            >
              <RBT.Modal.Header closeButton>
                <RBT.Modal.Title>Handled by Someone Else!</RBT.Modal.Title>
              </RBT.Modal.Header>
              <RBT.Modal.Body>
                <div className="delete-content">
                  <div>
                    <span>This lead is already being handled by </span> {this.state.is_handled_by}
                    <RBT.Button onClick={() => this.setState({ ishandledModal: false })}>
                      Okay
                    </RBT.Button>
                  </div>
                </div>
              </RBT.Modal.Body>
            </RBT.Modal>
            {/* End is handled modal */}

            {/* Start is handled modal */}
            <RBT.Modal
              className="live-chat-modal"
              centered
              show={(!(this.state.isAutoAssigned) && (this.state.ismanualHandledModal)) ? true : false}
              onHide={() => this.setState({ ismanualHandledModal: false })}
            >
              <RBT.Modal.Header closeButton>
                <RBT.Modal.Title>Handled Manually by Someone Else!</RBT.Modal.Title>
              </RBT.Modal.Header>
              <RBT.Modal.Body>
                <div className="delete-content">
                  <div>
                    <span>This lead is already being handled by </span> {this.state.is_handled_by}
                    <RBT.Button onClick={() => this.setState({ ismanualHandledModal: false })}>
                      Okay
                    </RBT.Button>
                  </div>
                </div>
              </RBT.Modal.Body>
            </RBT.Modal>
            {/* End is handled modal */}

            {/* Start contactIsLiveModal modal */}
            <RBT.Modal
              className="live-chat-modal"
              centered
              show={this.state.contactIsLiveModal}
              onHide={() => this.contactIsLiveModal(false)}
            >
              <RBT.Modal.Header closeButton>
                <RBT.Modal.Title>Lead is Live</RBT.Modal.Title>
              </RBT.Modal.Header>
              <RBT.Modal.Body>
                <div className="delete-content">
                  <div>
                    {
                      this.state.assignedContactID ?
                        <span>This lead is Live, you need to release the <p>auto-assigned lead to continue with this lead</p></span>
                        :
                        <span>This Lead is live now, <p>the system has been reloaded</p></span>
                    }
                    <RBT.Button onClick={() => this.contactIsLiveModal(false)}>
                      OK
                    </RBT.Button>
                  </div>
                </div>
              </RBT.Modal.Body>
            </RBT.Modal>
            {/* End Opt Out modal */}

            {/* Start add schedule modal */}
            <RBT.Modal
              className="live-chat-modal calender-and-clock-modal"
              centered
              show={this.state.addScheduleModalShow}
              onHide={() => this.leadScheduleActionModal('newSchedule')}
            >
              <RBT.Modal.Header closeButton>
                <RBT.Modal.Title>Add New Schedule</RBT.Modal.Title>
              </RBT.Modal.Header>
              <RBT.Modal.Body>
                <div className="add-schedule-modal only-add">
                  <div className="add-schedule-modal-btwn">
                    <div className="add-schedule-modal-btwn-text">
                      <FontAwesomeIcon icon={faIcon.faUser} /> {this.state.contact_name}
                      <span>{this.state.promo_name}</span>
                    </div>
                    <div className="add-schedule-modal-btwn-text">
                      <FontAwesomeIcon icon={faIcon.faBriefcase} /> {this.state.owner_name}
                    </div>
                    <div className="add-schedule-modal-btwn-text">
                      <FontAwesomeIcon icon={faIcon.faCalendarWeek} />Timezone: {this.state.owner_timezone_array ? this.state.owner_timezone_array.timezone : ''}
                    </div>
                    <hr />
                  </div>
                  <div className="row flatpickerDiv">
                    <Flatpickr
                      data-enable-time
                      onChange={(date) => {
                        this.setScheduleDate(date[0])
                      }}
                      options={{ inline: true, defaultDate: date }}
                    />
                    {this.state.chooseHour ?
                      <div className="time-content-hour">
                        <div className="close-choose-time" onClick={() => this.chooseHour(false)}>
                          <FontAwesomeIcon icon={faIcon.faChevronLeft} />
                        </div>
                        <div>
                          <ul>
                            <li className={''} onClick={(e) => this.selectHour(e, '01')}><button className="nav-link">01</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '02')}><button className="nav-link">02</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '03')}><button className="nav-link">03</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '04')}><button className="nav-link">04</button></li>
                          </ul>
                          <ul>
                            <li className={''} onClick={(e) => this.selectHour(e, '05')}><button className="nav-link">05</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '06')}><button className="nav-link">06</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '07')}><button className="nav-link">07</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '08')}><button className="nav-link">08</button></li>
                          </ul>
                          <ul>
                            <li className={''} onClick={(e) => this.selectHour(e, '09')}><button className="nav-link">09</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '10')}><button className="nav-link">10</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '11')}><button className="nav-link">11</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '12')}><button className="nav-link">12</button></li>
                          </ul>
                        </div>
                      </div>
                      :
                      ''
                    }
                    {
                      this.state.chooseMinute ?
                        <div className="time-content-minute">
                          <div className="close-choose-time" onClick={() => this.chooseMinute(false)}>
                            <FontAwesomeIcon icon={faIcon.faChevronLeft} />
                          </div>
                          <div>
                            <ul>
                              <li className={''} onClick={(e) => this.selectMinute(e, '00')}><button className="nav-link">00</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '05')}><button className="nav-link">05</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '10')}><button className="nav-link">10</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '15')}><button className="nav-link">15</button></li>
                            </ul>
                            <ul>
                              <li className={''} onClick={(e) => this.selectMinute(e, '20')}><button className="nav-link">20</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '25')}><button className="nav-link">25</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '30')}><button className="nav-link">30</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '35')}><button className="nav-link">35</button></li>
                            </ul>
                            <ul>
                              <li className={''} onClick={(e) => this.selectMinute(e, '40')}><button className="nav-link">40</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '45')}><button className="nav-link">45</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '50')}><button className="nav-link">50</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '55')}><button className="nav-link">55</button></li>
                            </ul>
                          </div>
                        </div>
                        :
                        ''
                    }
                  </div>
                  <div className="mt-3">
                    <div className="modalBttnWrapper">
                      <RBT.Button disabled={this.state.pleaseWait} onClick={() => this.leadScheduleAction('newSchedule')}>
                        {this.state.pleaseWait ? "Making Schedule..." : "Save"}
                      </RBT.Button>
                    </div>
                  </div>
                </div>
              </RBT.Modal.Body>
            </RBT.Modal>
            {/* End add schedule modal */}

            {/* Start reschedule modal */}
            <RBT.Modal
              className="live-chat-modal calender-and-clock-modal calender-and-clock-Reschedule"
              centered
              show={this.state.reScheduleModalShow}
              onHide={() => this.leadScheduleActionModal('reSchedule')}
            >
              <RBT.Modal.Header closeButton>
                <RBT.Modal.Title>Reschedule Appointment</RBT.Modal.Title>
              </RBT.Modal.Header>
              <RBT.Modal.Body>
                <div className="add-schedule-modal">
                  <div className="add-schedule-modal-btwn">
                    <div className="row">
                      <div className="col-6">
                        <div className="add-schedule-modal-btwn-text">
                          <FontAwesomeIcon icon={faIcon.faUser} /> {this.state.contact_name}
                          <span>{this.state.promo_name}</span>
                        </div>
                        <div className="add-schedule-modal-btwn-text">
                          <FontAwesomeIcon icon={faIcon.faBriefcase} /> {this.state.owner_name}
                        </div>
                        <div className="add-schedule-modal-btwn-text">
                          <FontAwesomeIcon icon={faIcon.faCalendarWeek} /> <b>TimeZone: </b> {this.state.owner_timezone_array ? this.state.owner_timezone_array.timezone : ''}
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="add-schedule-modal-btwn-text">
                          <FontAwesomeIcon icon={faIcon.faCalendarCheck} className="text-success" />
                          {this.state.scheduleDateRange}
                        </div>
                        <div className="add-schedule-modal-btwn-text">
                          <FontAwesomeIcon icon={faIcon.faClock} />
                          {this.state.scheduleTimeRange}
                        </div>
                      </div>
                    </div>
                    <hr />
                  </div>
                  <div className="row flatpickerDiv">
                    <Flatpickr
                      data-enable-time
                      onChange={date => {
                        this.setScheduleDate(date[0])
                      }}
                      options={{ inline: true, defaultDate: date }}
                    />
                    {this.state.chooseHour ?
                      <div className="time-content-hour">
                        <div className="close-choose-time" onClick={() => this.chooseHour(false)}>
                          <FontAwesomeIcon icon={faIcon.faChevronLeft} />
                        </div>
                        <div>
                          <ul>
                            <li className={''} onClick={(e) => this.selectHour(e, '01')}><button className="nav-link">01</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '02')}><button className="nav-link">02</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '03')}><button className="nav-link">03</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '04')}><button className="nav-link">04</button></li>
                          </ul>
                          <ul>
                            <li className={''} onClick={(e) => this.selectHour(e, '05')}><button className="nav-link">05</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '06')}><button className="nav-link">06</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '07')}><button className="nav-link">07</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '08')}><button className="nav-link">08</button></li>
                          </ul>
                          <ul>
                            <li className={''} onClick={(e) => this.selectHour(e, '09')}><button className="nav-link">09</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '10')}><button className="nav-link">10</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '11')}><button className="nav-link">11</button></li>
                            <li className={''} onClick={(e) => this.selectHour(e, '12')}><button className="nav-link">12</button></li>
                          </ul>
                        </div>
                      </div>
                      :
                      ''
                    }
                    {
                      this.state.chooseMinute ?
                        <div className="time-content-minute">
                          <div className="close-choose-time" onClick={() => this.chooseMinute(false)}>
                            <FontAwesomeIcon icon={faIcon.faChevronLeft} />
                          </div>
                          <div>
                            <ul>
                              <li className={''} onClick={(e) => this.selectMinute(e, '00')}><button className="nav-link">00</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '05')}><button className="nav-link">05</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '10')}><button className="nav-link">10</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '15')}><button className="nav-link">15</button></li>
                            </ul>
                            <ul>
                              <li className={''} onClick={(e) => this.selectMinute(e, '20')}><button className="nav-link">20</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '25')}><button className="nav-link">25</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '30')}><button className="nav-link">30</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '35')}><button className="nav-link">35</button></li>
                            </ul>
                            <ul>
                              <li className={''} onClick={(e) => this.selectMinute(e, '40')}><button className="nav-link">40</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '45')}><button className="nav-link">45</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '50')}><button className="nav-link">50</button></li>
                              <li className={''} onClick={(e) => this.selectMinute(e, '55')}><button className="nav-link">55</button></li>
                            </ul>
                          </div>
                        </div>
                        :
                        ''
                    }
                  </div>
                  <div className="mt-3">
                    <div className="modalBttnWrapper">
                      <RBT.Button disabled={this.state.pleaseWait} onClick={() => this.leadScheduleAction('reSchedule')}>
                        {this.state.pleaseWait ? "Rescheduling..." : "Reschedule Appointment"}
                      </RBT.Button>
                    </div>
                  </div>
                </div>
              </RBT.Modal.Body>
            </RBT.Modal>
            {/* End reschedule modal */}

            {/* Start Calcel Schedule modal */}
            <RBT.Modal
              className="live-chat-modal"
              centered
              show={this.state.cancelScheduleModalShow}
              onHide={() => this.leadScheduleActionModal('cancelSchedule')}
            >
              <RBT.Modal.Header closeButton>
                <RBT.Modal.Title>Cancel Schedule</RBT.Modal.Title>
              </RBT.Modal.Header>
              <RBT.Modal.Body>
                <div className="delete-content">
                  <div>
                    <span>Are you sure,</span> you want to cancel this appointment?
                    <RBT.Button disabled={this.state.pleaseWait} onClick={() => this.leadScheduleAction('cancelSchedule')}>
                      {this.state.pleaseWait ? "Cancelling..." : "Yes"}
                    </RBT.Button>
                  </div>
                </div>
              </RBT.Modal.Body>
            </RBT.Modal>
            {/* End Calcel Schedule modal */}

            {/* Start lead action modal */}
            <RBT.Modal
              className="live-chat-modal"
              centered
              show={this.state.leadActionModalDisplay}
              onHide={() => this.leadActionModal()}
            >
              <RBT.Modal.Header closeButton>
                <RBT.Modal.Title>{this.state.leadActionModalTitle}</RBT.Modal.Title>
              </RBT.Modal.Header>
              <RBT.Modal.Body>
                <div className="delete-content">
                  <div>
                    {Parser(`${this.state.leadActionModalBody}`)}
                    <RBT.Button disabled={this.state.pleaseWait} onClick={() => this.leadAction()}>
                      {this.state.pleaseWait ? "Wait..." : "Yes"}
                    </RBT.Button>
                  </div>
                </div>
              </RBT.Modal.Body>
            </RBT.Modal>
            {/* End lead action modal */}

          </div>
          {/* end message area */}

          <div className="main-chat-container main-chat-container-right">
            <ScheduleMessageArea
              acuityCalendarLoading={this.state.acuityCalendarLoading}
              acuityurl={this.state.acuityurl}
              showIframe={this.state.showIframe}
              owner_name={this.state.owner_name}
              current_contact={this.state.currentContactID}
              current_gym_owner={this.state.currentGymOwnerID}
              shortCodeLoading={true}
              shortCodeList={this.state.shortCodeList}
              errorShortCodeMessage={this.state.errorShortCodeMessage}
              mostUsedShortcodeLoading={this.state.mostUsedShortcodeLoading}
              mostUsedShortCodeList={this.state.mostUsedShortCodeList}
              errorMostUsedShortCodeMessage={this.state.errorMostUsedShortCodeMessage}
              Socket={this.state.Socket}
              pauseScheduleMessage={this.state.pauseScheduleMessage}
            />
            <ShortcodeArea
              current_contact={this.state.currentContactID}
              current_gym_owner={this.state.currentGymOwnerID}
              shortCodeLoading={true}
              shortCodeList={this.state.shortCodeList}
              errorShortCodeMessage={this.state.errorShortCodeMessage}
              mostUsedShortcodeLoading={this.state.mostUsedShortcodeLoading}
              mostUsedShortCodeList={this.state.mostUsedShortCodeList}
              errorMostUsedShortCodeMessage={this.state.errorMostUsedShortCodeMessage}
              Socket={this.state.Socket}
            />
          </div>
        </Fragment>
        :
        <div className="emptyChatbox text-center">
          <div>
            <img src={require("../../Assets/images/usealan_logo.png").default} alt="choose lead" />
            <br />
            <span>Choose Lead</span>
          </div>
        </div>
    );
  }
}

// export default LivechatMain;
Conversations.propTypes = {
  auth: PropTypes.object.isRequired,
  autoassign: PropTypes.func.isRequired,
  setfullstory: PropTypes.func.isRequired,
  setLeadProcessStatus: PropTypes.func.isRequired,
  setReloadReply: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    isAutoAssignable: state.auth.isAutoAssignable,
    isFullStory: state.auth.isFullStory,
    leadProcessStatus: state.auth.leadProcessStatus,
    reloadReply: state.auth.reloadReply,
  };
}
export default connect(mapStateToProps, { autoassign, setfullstory, setLeadProcessStatus, setReloadReply })(Conversations);